module.exports = __webpack_public_path__ + "static/img/jt.1040fbc.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/jt.png
// module id = +Ge5
// module chunks = 1